import actionTypes from 'SRC/modules/redux/actionTypes'

export const setFilteredFields = filteredFields => ({
  type: actionTypes.SET_VEHICLE_PARTS_FILTERED_FIELDS,
  payload: filteredFields
})
